// Hands a selected live flight from the results tab to the details tab it opens.
// localStorage is shared between tabs; entries expire so stale fares are not reused.
const PREFIX = 'tripfresh.flightSelection.';
const MAX_AGE_MS = 6 * 60 * 60 * 1000;

function prune(now) {
  try {
    Object.keys(window.localStorage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => {
        const saved = JSON.parse(window.localStorage.getItem(key) || 'null');
        if (!saved || now - saved.savedAt > MAX_AGE_MS) window.localStorage.removeItem(key);
      });
  } catch {
    // Storage unavailable or corrupt entry; nothing to prune.
  }
}

export function saveSelection(selection) {
  const now = Date.now();
  prune(now);
  const id = `${now.toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  try {
    window.localStorage.setItem(PREFIX + id, JSON.stringify({ ...selection, savedAt: now }));
  } catch {
    return null;
  }
  return id;
}

/** The flight with one fare family chosen: its offer reference, price and fare details. */
export function withFare(flight, fare) {
  if (!fare) return flight;
  const offer = {
    ...flight.offer,
    totalPrice: fare.price,
    details: {
      ...flight.offer.details,
      offerReference: fare.ref,
      fareIdentifier: fare.type,
      refundType: fare.refund,
      cabinBaggage: fare.cabinBag,
      checkinBaggage: fare.checkinBag,
      mealIncluded: fare.meal ? 'true' : '',
      seatsLeft: fare.seatsLeft ? String(fare.seatsLeft) : '',
      fareOptions: '',
    },
  };
  return {
    ...flight, offer, fares: [fare], price: fare.price, refund: fare.refund, cabinBag: fare.cabinBag,
    checkinBag: fare.checkinBag, meal: fare.meal, seatsLeft: fare.seatsLeft, fareName: fare.name,
  };
}

export function loadSelection(id) {
  try {
    const saved = JSON.parse(window.localStorage.getItem(PREFIX + id) || 'null');
    return saved && Date.now() - saved.savedAt <= MAX_AGE_MS ? saved : null;
  } catch {
    return null;
  }
}
